/* eslint-disable react/jsx-no-target-blank,i18next/no-literal-string */
import Screen from 'components/layout/Screen'
import { useReseller } from 'state/Reseller'

export default function HelpPage() {
	const reseller = useReseller()
	const email    = reseller? reseller.email : 'support@ehungry.com'
	const phone    = reseller?.support_phone_number

	return <Screen back title="Help">
		<Screen.Content addPadding>
			<h2>This is a shame, but...</h2>
			<p>
				This page isn't ready yet.<br/>
				{/* eslint-disable-next-line react/jsx-no-target-blank */}
				In the meantime, you can{' '}
				{phone && <><a href={`tel:${phone}`}>call us at <tt className="text-nowrap">{phone}</tt></a> or </>}
				<a href={`mailto:${email}?subject=Orders+Manager+app+help`} target="_blank">email us</a>.
			</p>
		</Screen.Content>
	</Screen>
}
